import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../components/layout/Layout";
import Pagination from "./../../components/Pagination";
import SortList from "../../components/sortlist/SortList";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  ordersDelete,
  ordersList,
  multiOrderDelete,
} from "../../redux/action/order";
import { ToastContainer } from "react-toastify";
import dateFormat from "dateformat";
import { fleetList } from "../../redux/action/fleet";
import { staffList } from "../../redux/action/staff";
// import search from "../../utils/search";
import { CSVLink } from "react-csv";
import { io } from "socket.io-client";
import { APIURL, SOCETCONNURL } from "../../redux/action/config";
import loader from "../../components/loader/loader";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import CancelOrder from "./CancelOrder";

const Orders = ({ pageLoding, OrderList, notFoundOrder }) => {
  const headers = [
    { label: "_id", key: "id" },
    { label: "SR No.", key: "request" },
    { label: "Customer Name", key: "name" },
    { label: "Phone Number", key: "phone" },
    { label: "Email Address", key: "email" },
    { label: "Date", key: "date" },
    { label: "Staff Assigned", key: "staff" },
    { label: "Fleet Assigned", key: "fleet" },
    { label: "Requested Service", key: "service" },
    { label: "Purchased Membership", key: "membership" },
    { label: "Order Status", key: "status" },
    { label: "Work status", key: "status" },
    { label: "Created_At", key: "created" },
    { label: "Updated_At", key: "updated" },
  ];

  const [loading, setLoading] = React.useState(true);
  const [orders, setOrders] = useState([]);

  setTimeout(() => {
    setLoading(false);
  }, 2000);

  // const [productDataList, setProductDataList] = useState([]);
  const orderList = useSelector((state) => state.order.new_orders);
  const FleetData = useSelector((state) => state.fleet.list);
  const StaffData = useSelector((state) => state.staff.list);

  const { pagination } = useSelector((state) => state.order);
  const [listData, setListData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const onChangePage = (page) => {
    dispatch(ordersList(page, searchQuery, 10, startDate, endDate, statusFilter));
  };

  const applySearch = () => {
    dispatch(ordersList(1, searchQuery, 10, startDate, endDate, statusFilter));
  };

  const handleStatusFilterChange = (e) => {
    const value = e.target.value;
    setStatusFilter(value);
    dispatch(ordersList(1, searchQuery, 10, startDate, endDate, value));
  };

  useEffect(() => {
    setListData(orderList);
  }, [orderList]);
  useEffect(() => {
    const socket = io(SOCETCONNURL);
    socket.on("order-list", (items) => {
      setOrders(items);
    });
    socket.on("disconnect", () => {
      console.log("Socket disconnecting");
    });
  }, []);

  // console.log(orderList, "orderListorderList");
  // const data = orderList?.map((item) => {
  //   const assignedStaff =
  //     StaffData && StaffData?.filter((items) => item?.staff_id == items?._id);

  //   const assignedFleet = FleetData?.data?.fleet?.filter(
  //     (items) => item?.fleet_id?._id == items?._id
  //   );
  //   return {
  //     id: item?._id,
  //     request: item?.invoice_no,
  //     name: `${
  //       item?.customer_id?.firstName ? item?.customer_id?.firstName : ""
  //     } ${item?.customer_id?.lastName ? item?.customer_id?.lastName : ""}`,
  //     phone: item?.customer_id?.phone,
  //     email: item?.customer_id?.email,
  //     date: dateFormat(item?.createdAt, "d mmmm , yyyy, hh:mm:ss"),
  //     staff: assignedStaff?.[0]?.firstName
  //       ? `${
  //           assignedStaff?.[0]?.firstName ? assignedStaff?.[0]?.firstName : ""
  //         } ${assignedStaff?.[0]?.lastName ? assignedStaff?.[0]?.lastName : ""}`
  //       : "N/A",
  //     fleet: assignedFleet?.[0]?.name ? assignedFleet?.[0]?.name : "N/A",
  //     service: item?.service_id?.name,
  //     membership: item?.membership_id?.name ? item?.membership_id?.name : "N/A",
  //     status: item?.status,
  //     created: item?.createdAt,
  //     updated: item?.updatedAt,
  //   };
  // });

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(ordersList());
    dispatch(fleetList());
    dispatch(staffList());
  }, [dispatch]);

  const ordersDel = async (id) => {
    const res = await dispatch(ordersDelete(id));
    if (res?.data?.status == "success") {
      setListData(listData.filter((o) => o.id != id));
    }
    setTimeout(() => {
      dispatch(ordersList());
    }, 1000);
  };
  const recentOrderStatus = (status) => {
    switch (status) {
      case "order_initiated":
        return "Order Initiated";
      case "order_placed":
        return "Order Placed";
      case "order_in_progress":
        return "Order In Progress";
      case "order_completed":
        return "Completed";
      case "order_canceled":
        return "Order Canceled";
      default:
    }
  };
  const recentOrderColor = (status) => {
    switch (status) {
      case "order_initiated":
        return "badge-light-dark";
      case "order_placed":
        return "badge-light-info";
      case "order_in_progress":
        return "badge-light-warning";
      case "order_completed":
        return "badge-green";
      case "order_canceled":
        return "badge-light-danger";
      default:
    }
  };

  const taskStatus = (status) => {
    switch (status) {
      case "n/a":
        return "Staff will assigned soon";
      case "staff_assigned":
        return "Staff assigned";
      case "reached_at_location":
        return "Staff reached at location";
      case "setting_safety_items":
        return "Setting safety items";
      case "access_situation":
        return "Access situation";
      case "rectifiying_problem":
        return "Rectifiying problem";
      case "towing_required":
        return "Towing required";
      case "task_completed":
        return "Completed";
      default:
    }
  };
  const taskStatusColor = (status) => {
    switch (status) {
      case "n/a":
        return "badge-light-dark";
      case "staff_assigned":
        return "badge-light-info";
      case "reached_at_location":
        return "badge-light-dark";
      case "setting_safety_items":
        return "badge-light-info";
      case "access_situation":
        return "badge-light-warning";
      case "rectifiying_problem":
        return "badge-light-info";
      case "towing_required":
        return "badge-light-danger";
      case "task_completed":
        return "badge-green";
      default:
    }
  };
  // *********** All Select Delete ***********
  const [btnStatus, setBtnStatus] = useState(false);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  const [cancelOrderId, setCancelOrderId] = useState(null);
  const [oData, setOData] = useState();

  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(listData.map((li) => li.id));
    if (isCheckAll) {
      setIsCheck([]);
    }
  };

  const handleClick = (e) => {
    const { id, checked } = e.target;
    setIsCheck([...isCheck, id]);
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item !== id));
    }
  };

  const handleAllDelete = () => {
    multiOrderDelete(isCheck);
    setTimeout(() => {
      dispatch(ordersList());
      setIsCheckAll(false);
      setIsCheck([]);
    }, 1000);
  };

  // Download csv files - export the selected rows, or the whole visible list if nothing is checked
  const seledCsvList =
    isCheck?.length > 0
      ? listData?.filter((item) => isCheck?.includes(item?.id))
      : listData;

  const data =
    seledCsvList &&
    seledCsvList?.map((item) => {
      const assignedStaff =
        Array.isArray(StaffData) &&
        StaffData.filter((items) => item?.staff_id == items?._id);

      const assignedFleet = FleetData?.data?.fleet?.filter(
        (items) => item?.fleet_id?._id == items?._id
      );
      return {
        id: item?._id,
        request: item?.invoice_no,
        name: `${
          item?.customer_id?.firstName ? item?.customer_id?.firstName : ""
        } ${item?.customer_id?.lastName ? item?.customer_id?.lastName : ""}`,
        phone: item?.customer_id?.phone,
        email: item?.customer_id?.email,
        date: dateFormat(item?.createdAt, "d mmmm , yyyy, hh:mm:ss"),
        staff: assignedStaff?.[0]?.firstName
          ? `${
              assignedStaff?.[0]?.firstName ? assignedStaff?.[0]?.firstName : ""
            } ${
              assignedStaff?.[0]?.lastName ? assignedStaff?.[0]?.lastName : ""
            }`
          : "N/A",
        fleet: assignedFleet?.[0]?.name ? assignedFleet?.[0]?.name : "N/A",
        service: item?.service_id?.name,
        membership: item?.membership_id?.name
          ? item?.membership_id?.name
          : "N/A",
        status: item?.status,
        created: item?.createdAt,
        updated: item?.updatedAt,
      };
    });

  // pdf code start
  const downloadPDF = () => {
    const capture = document.querySelector(".table");
    html2canvas(capture).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      console.log("Image Data:", imgData); // Debugging: Log the image data
      const doc = new jsPDF("p", "mm", "a4");
      const imgWidth = 200; // Adjust this based on your needs
      const imgHeight = (imgWidth * canvas.height) / canvas.width; // Maintain aspect ratio
      doc.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      doc.save("roadside-response.pdf");
    });
  };
  // pdf code end
  // date filter start

  const [filterDate, setFilterData] = useState({
    startDate: "",
    endDate: "",
  });

  const startDate = filterDate?.startDate;
  const endDate = filterDate?.endDate;
  const handleOnchangeFilter = (e) => {
    const { name, value } = e.target;
    const newFilterDate = { ...filterDate, [name]: value };
    setFilterData(newFilterDate);

    // If both dates are present (or if changing one while the other is present)
    // Actually, maybe we should fetch if ANY date is set? Or only when endDate is set?
    // The previous logic was: if (!endDate) return;

    // Let's stick to the user's workflow or standard: usually fetch when both are set or on blur/search button.
    // Given the previous code: useEffect triggered on [startDate, endDate].

    if (name === "endDate" && value && newFilterDate.startDate) {
      dispatch(
        ordersList(1, searchQuery, 10, newFilterDate.startDate, value, statusFilter)
      );
    } else if (name === "startDate" && value && newFilterDate.endDate) {
      dispatch(
        ordersList(1, searchQuery, 10, value, newFilterDate.endDate, statusFilter)
      );
    }
  };

  const handleResetFilter = () => {
    setFilterData({ startDate: "", endDate: "" });
    dispatch(ordersList(1, searchQuery, 10, "", "", statusFilter));
  };

  // Removed client-side filterData
  // useEffect(() => {
  //   if (!endDate) return;
  //   return filterData();
  // }, [startDate, endDate]);
  // const filterData = () => { ... }
  // date filter end

  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />
      <Layout title="All Orders" page="orders">
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div id="kt_content_container" className="container-fluid">
            <div className="row g-5 g-xxl-10">
              <div className="col-xl-12 col-xxl-12 mb-5 mb-xxl-12">
                <div
                  id="kt_datatable_example_5_wrapper"
                  className="dataTables_wrapper dt-bootstrap4 no-footer"
                >
                  <div className="row pt-4 pb-4">
                    <div className="col-sm-6 d-flex align-items-center justify-conten-start">
                      <div
                        className="dataTables_length"
                        id="kt_datatable_example_5_length"
                      >
                        <div className="filter-table-data ml-5 d-flex align-items-center">
                          {isCheck && isCheck?.length > 0 ? (
                            <button
                              onClick={() => {
                                handleAllDelete();
                              }}
                              className="delete-selected me-4"
                            >
                              Delete Selected
                            </button>
                          ) : (
                            ""
                          )}
                          <div className="">
                            <input
                              className="form-control"
                              name="startDate"
                              type="date"
                              value={startDate}
                              onChange={(e) => {
                                handleOnchangeFilter(e);
                              }}
                            />
                          </div>
                          <span className="mx-4 fw-bolder">To</span>
                          <div>
                            <input
                              className="form-control"
                              name="endDate"
                              type="date"
                              min={startDate || ""}
                              value={endDate}
                              onChange={(e) => {
                                handleOnchangeFilter(e);
                              }}
                            />
                          </div>
                          <div className="ms-4">
                            <select
                              className="form-select"
                              name="status"
                              value={statusFilter}
                              onChange={handleStatusFilterChange}
                            >
                              <option value="">All Statuses</option>
                              <option value="order_initiated">Order Initiated</option>
                              <option value="order_placed">Order Placed</option>
                              <option value="order_in_progress">Order In Progress</option>
                              <option value="order_completed">Completed</option>
                              <option value="order_canceled">Order Canceled</option>
                            </select>
                          </div>
                          {(startDate || endDate) ? (
                            <button
                              type="button"
                              className="btn btn-light-danger ms-2"
                              onClick={handleResetFilter}
                            >
                              Reset
                            </button>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6 d-flex align-items-center justify-content-end">
                      <div
                        id="kt_datatable_example_5_filter"
                        className="dataTables_filter"
                      >
                        <label className="w-100">
                          <span className="me-2">Search:</span>

                          <div className="position-relative w-100">
                            <input
                              type="search"
                              value={searchQuery}
                              onChange={(e) => {
                                setSearchQuery(e.target.value);
                                if (e.target.value === "") {
                                  dispatch(
                                    ordersList(
                                      1,
                                      "",
                                      10,
                                      startDate,
                                      endDate,
                                      statusFilter
                                    )
                                  );
                                }
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  applySearch();
                                }
                              }}
                              className="form-control form-control-sm form-control-solid pe-10"
                              placeholder="Search..."
                              aria-controls="kt_datatable_example_5"
                            />

                            {/* Button INSIDE input */}
                            {searchQuery !== "" && (
                              <button
                                type="button"
                                onClick={applySearch}
                                className="btn btn-sm btn-icon position-absolute top-50 end-0 translate-middle-y me-1"
                                aria-label="Search"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="12"
                                  height="12"
                                  fill="currentColor"
                                  className="bi bi-search"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                </svg>
                              </button>
                            )}
                          </div>
                        </label>
                      </div>

                      <div className="ms-3">
                        <a
                          className="btn pgf btn-secondary dropdown-toggle"
                          href="#"
                          // role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          // className="csvlink"
                          style={{ background: "none" }}
                        >
                          Download File
                        </a>

                        <ul className="dropdown-menu">
                          <li>
                            <a className="dropdown-item">
                              <CSVLink
                                style={{ color: "#000" }}
                                data={data}
                                headers={headers}
                              >
                                Download as CSV
                              </CSVLink>
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" onClick={downloadPDF}>
                              Download as PDF
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="table-responsive table-wrapper">
                    <table
                      id="kt_datatable_example_5"
                      className="table table-striped table-row-bordered gy-5 gs-7 border rounded dataTable no-footer"
                    >
                      <thead>
                        <tr className="fw-bolder fs-6 text-gray-800 px-7 arrow-none">
                          <th style={{ padding: "16px 0px 16px 24px" }}>
                            <input
                              type="checkbox"
                              name="selectAll"
                              id="selectAll"
                              onClick={() => {
                                handleSelectAll();
                                setBtnStatus(true);
                              }}
                              checked={isCheckAll}
                              className="form-check-input custum-check"
                            />
                          </th>
                          <th style={{ width: "50px" }}>SR No.</th>
                          <th style={{ width: "122.281px" }}>Customer Name</th>
                          <th style={{ width: "128.172px" }}>Staff Assigned</th>
                          <th style={{ width: "128.172px" }}>Fleet Assigned</th>
                          <th style={{ width: "159.938px" }}>Date & Time</th>
                          <th style={{ width: "100px" }}>Order Status</th>
                          <th style={{ width: "100px" }}>Work status</th>
                          <th style={{ width: "175.719px" }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listData?.length > 0 ? (
                          listData?.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td
                                  style={{ width: "20px" }}
                                  className="check-list"
                                >
                                  <input
                                    type="checkbox"
                                    name={item?.firstName}
                                    id={item?.id}
                                    onClick={(e) => handleClick(e)}
                                    checked={isCheck.includes(item?.id)}
                                    className="form-check-input custum-check"
                                  />
                                </td>
                                <td>{item?.invoice_no}</td>
                                <td>{`${
                                  item?.customer_id?.firstName
                                    ? item?.customer_id?.firstName
                                    : ""
                                } ${
                                  item?.customer_id?.lastName
                                    ? item?.customer_id?.lastName
                                    : ""
                                }`}</td>
                                <td>
                                  {item?.staffs_id?.firstName
                                    ? item?.staffs_id?.firstName +
                                      "" +
                                      item?.staffs_id?.lastName
                                    : "N/A"}
                                </td>
                                <td>
                                  {item?.fleet_id?.name
                                    ? item?.fleet_id?.name
                                    : "N/A"}
                                </td>
                                <td>
                                  {item?.createdAt
                                    ? dateFormat(
                                        item?.createdAt,
                                        "mm/dd/yyyy HH:mm:ss"
                                      )
                                    : "N/A"}
                                </td>
                                <td>
                                  <span
                                    className={`badge ${recentOrderColor(
                                      item?.status
                                    )}`}
                                  >
                                    {recentOrderStatus(item?.status)}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    className={`badge ${taskStatusColor(
                                      item?.task_status
                                    )}`}
                                  >
                                    {taskStatus(item?.task_status)}
                                  </span>
                                </td>
                                <td style={{ width: "200px" }}>
                                  <Link
                                    to={`/order-detail/${item.id}`}
                                    className="btn btn-bg-primary action-hover"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-eye-fill"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                      <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                                    </svg>
                                  </Link>
                                  <Link
                                    to={`/edit-order/${item.id}`}
                                    className="btn btn-info action-hover"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-pencil-square"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                      <path
                                        fillRule="evenodd"
                                        d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                      />
                                    </svg>
                                  </Link>
                                  <Link
                                    to="/orders"
                                    onClick={() => ordersDel(item.id)}
                                    className="btn btn-bg-dark action-hover"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-trash-fill"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                                    </svg>
                                  </Link>
                                  <Link
                                    to="#"
                                    onClick={() => {
                                      setCancelOrderId(item.id);
                                      setOData(item);
                                    }}
                                    className="btn btn-bg-danger action-hover"
                                    data-bs-toggle="modal"
                                    data-bs-target="#orderCancel"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-x-circle-fill"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.646 4.646a.5.5 0 0 0-.708.708L7.293 8 3.938 11.354a.5.5 0 1 0 .708.708L8 8.707l3.354 3.355a.5.5 0 0 0 .708-.708L8.707 8l3.355-3.354a.5.5 0 0 0-.708-.708L8 7.293 4.646 4.646z" />
                                    </svg>
                                  </Link>
                                  <CancelOrder
                                    modalId={"orderCancel"}
                                    id={cancelOrderId}
                                    data={oData}
                                  />
                                </td>
                              </tr>
                            );
                          })
                        ) : orderList?.length === 0 ||
                          listData?.length === 0 ? (
                          <div className="spinner-outer p-5">
                            <p>Data not found</p>
                          </div>
                        ) : (
                          <div className="spinner-outer p-5">{loader()}</div>
                        )}
                      </tbody>
                    </table>
                  </div>

                  <Pagination
                    pageSize={10}
                    items={listData}
                    onChangePage={onChangePage}
                    serverSide={true}
                    initialPage={pagination?.page}
                    totalItems={pagination?.total}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  pageLoding: state?.order?.loading,
  OrderList: state?.order?.new_orders,
  notFoundOrder: state?.order?.not_found,
});

export default connect(mapStateToProps, { ordersList })(Orders);
